import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ColorFamily } from '@ppg/core/models';

import { ColorFamilySwitcherItemComponent } from '../color-family-switcher-item/color-family-switcher-item.component';

@Component({
  selector: 'ppg-color-family-switcher',
  standalone: true,
  imports: [ColorFamilySwitcherItemComponent],
  templateUrl: './color-family-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorFamilySwitcherComponent {
  readonly defaultStyle = 'col-6 sm:col-3 md:col-2';

  readonly colorFamilies = input.required<ColorFamily[]>();
  readonly selectedColorFamily = input.required<ColorFamily | undefined>();
  readonly customStyle = input<string | undefined>(this.defaultStyle);
  readonly colorFamilySelected = output<ColorFamily>();

  onColorFamilySelected(colorFamily: ColorFamily): void {
    this.colorFamilySelected.emit(colorFamily);
  }
}
